module.exports = __webpack_public_path__ + "img/118.b3ef7ab1.jpg";